<script>
    export default {
        props: ['contact','deleteMailUrl'],

        data: function(){
            return  {
                waitingServerResponse: false,
            };
        },

        mounted: function(){
            $(this.$refs.termsDeleteModal).on("hidden.bs.modal", this.switch)
        },

        methods: {
            onDelete: function(event){
                if(!this.waitingServerResponse) {
                    this.waitingServerResponse = true;
                    this.$http.post(
                        this.deleteMailUrl,
                        {
                            contact: this.contact
                        },
                        {   headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    ).then(function(response){
                        if(response.status===204){
                            window.location.reload()
                        }
                    }).catch((error)=>{
                        console.error(error);
                        window.location.reload();
                    }).finally(() => {
                        this.waitingServerResponse = false;
                    });
                }
            }
        }
    };

</script>
